import { Form } from "antd";
import { PublishPermissionContentEmployeeFormItem } from "./publish-permission-content-employee-form-item";

export const PublishPermissionContentEmployeeForm = () => {
  return (
    <Form.Item name="employeeData" rules={[{ required: true, message: "Vui lòng chọn nhân viên cần ban hành đến" }]}>
        <PublishPermissionContentEmployeeFormItem />
    </Form.Item>
  );
};
